const SimulationEvent = require("./SimulationEvent");
const {convert, getWageByPref, checkFields} = require("./helper/labour");

const config = {
  days: 25,
  price: 626,
  rate: 80
}

class Food extends SimulationEvent {
  constructor(elements, emit, events) {
    super();
    this.elements = elements;
    this.inputs = {
      number: 0,
      option: false
    }
    this.emit = emit;
    this.events = events;
    this.totalCost = 0;
    this.init();
  }

  // 値（インプット）の変化の監視
  init() {
    super.triggerAll(this.elements);
    // 定員数の値が変化した時
    this.watch(this.elements.capacityEle, (e) => {

      this.inputs = {
        ...this.inputs,
        number: parseInt(e.target.value)
      }

      if (this.inputs.option) {
        this.calcTotalCost();
      }
    })

    // 委託内容が変化した時
    const checkboxes = this.elements.optionsEle.querySelectorAll(".checkbox")
    for (const checkbox of Array.from(checkboxes)) {
      this.watch(checkbox, (e) => {
        if (e.target.value === "food-service") {
          this.inputs = {
            ...this.inputs,
            option: e.target.checked
          }

          if (!e.target.checked) return this.resetTotalCost();

          if (this.inputs.number && this.inputs.option) {
            this.calcTotalCost();
          }
        }

      })
    }
  }

  setInputs({capacityEle, optionsEle}) {
    const option = optionsEle.indexOf("food-service") >= 0;
    this.inputs = {
      number: parseInt(capacityEle),
      option
    }
    if (this.inputs.number && this.inputs.option) {
      this.calcTotalCost();
    }
  }


  calcTotalCost() {

    this.totalCost = this.inputs.number * config.days * config.price * (config.rate / 100);


    this.emit("food", this.totalCost);
  }

  resetTotalCost() {
    this.totalCost = 0;
    this.emit("food", this.totalCost);
  }

  getTotalCost() {
    if (!this.totalCost) return 0;
    return this.totalCost;
  }


}

module.exports = Food;
